import {UserClient} from '../clients/UserClient';
import UserPermission from "@/models/lms/UserPermission";
import User from "@/models/lms/User";


import VueCookies from 'vue-cookies';

export const AuthModule = {
    namespaced: true,

    state: {
        user: null,
        requestedHandshake: false,
        authMessage: null,
    },
    mutations: {
        RESET_AUTH(state) {
            state.user = null
            state.requestedHandshake = false
            state.authMessage = null
        },
        SET_USER(state, user) {
            state.user = user
        }
    },

    actions: {
        delete({
                   commit
               }) {
            commit('RESET_AUTH')
            VueCookies.remove("lmsAccessToken");
            VueCookies.remove("lmsAccessToken");
            VueCookies.remove("lmsTenantId");
            VueCookies.remove("tenant_storage");
            VueCookies.remove("sisAccessToken");
            VueCookies.remove("sisTenantId");
            VueCookies.remove("SecondRefresh");
            VueCookies.remove("tenant_slug");
            VueCookies.remove("tenant_school_name");
            VueCookies.remove('lmsAccessToken');
        },
        async getUser({
              commit,
              state,
              rootState
          }, callbacks = {}) {
            try {
                // const {data: {data}} = await UserClient.getUser(rootState.cometChat.chatEnabled)
                // const {data: {data}} = await User.GetUser(rootState.cometChat.chatEnabled)
                const {response: {data: {data}}} = await User.GetUser(rootState.cometChat.chatEnabled)
                const {attributes} = data

                const user = {
                    id: data.id,
                    uuid: attributes.uuid,
                    sis_user_id: attributes.sis_user_id,
                    email: attributes.email,
                    first_name: attributes.first_name,
                    is_current_user: attributes.is_current_user,
                    last_name: attributes.last_name,
                    profile_image: attributes.profile_image,
                    roles: attributes.roles,
                    accepted_popia_at: attributes.accepted_popia_at,
                }
                commit('SET_USER', user)

                const permissionData = attributes.roles.map((role) => {
                    return role.attributes.permissions.map((permission) => {
                        return {
                            id: permission.id,
                            name: permission.attributes?.name,
                        }
                    });
                });

                await UserPermission.insert({
                    data: permissionData,
                })

                if (callbacks.success()) await callbacks.success();
            } catch (e) {
                if (callbacks.error()) await callbacks.error();
            }
        }
    },
}